import "./App.css";
import Products from "./components/Products";

const App = () => {
  return <Products />;
};

export default App;
